<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：提货站点-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加店员-->
      <div class="common-form">添加商户</div>
      <el-form-item label="店铺类型">
        <el-radio-group v-model="form.supplier.storeType">
          <el-radio :label="10">分销商店铺</el-radio>
          <el-radio :label="20">供应商店铺</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商户等级" prop="supplier.level" v-if="form.supplier.storeType === 10">
        <el-select style="width: 460px" v-model="form.supplier.level" placeholder="选择商户等级">
          <el-option v-for="(item, index) in levelList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="父级商户" prop="supplier.parentId"
                    v-if="form.supplier.storeType === 10 && form.supplier.level ">
        <div class="max-w460" @click="onSupplierChoose">
          <el-input class="max-w460" readonly v-model="form.supplier.parentName"
                    placeholder="请选择商户"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="抽成比例" prop="supplier.commissionRate" :rules="[{required: true,message: ' '}]"
                    v-if="form.supplier.storeType === 10">
        <el-input style="width: 200px;" type="number" v-model="form.supplier.commissionRate"
                  placeholder="请输入抽成比例"></el-input>
        %
      </el-form-item>
      <el-form-item label="商户名称" prop="supplier.name" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入商户名称"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称" prop="supplier.shopName" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.shopName" placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="supplier.userName" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.userName" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="supplier.password" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.supplier.password" placeholder="请输入登录密码" type="password"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="supplier.confirmPassword" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.supplier.confirmPassword" placeholder="请输入确认密码" type="password"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系人员" prop="supplier.linkName" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.linkName" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="supplier.linkPhone" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.linkPhone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="店铺标识" prop="supplier.logoId" :rules="[{required: true,message: ' '}]">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
          <div v-if="form.supplier.logoId!=''" class="img">
            <img :src="logoFilePath" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="主营类别" prop="supplier.categoryId" :rules="[{required: true,message: ' '}]">
        <el-select style="width: 460px" v-model="form.supplier.categoryId" placeholder="请选择">
          <el-option v-for="(item, index) in category" :key="index" :label="item.name"
                     :value="item.categoryId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户地址" prop="supplier.address" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.address" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="营业执照">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('business')">选择图片</el-button>
          <div v-if="form.supplier.businessId" class="img">
            <img :src="businessFilePath" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="经营许可证">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('operates')">选择图片</el-button>
          <div v-if="form.supplier.operatesId" class="img">
            <img :src="operatesFilePath" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="绑定用户">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="userClick()">选择用户</el-button>
          <div v-if="form.supplier.userId" class="img">
            <img v-img-url="userInfo.avatarurl" header="true" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="是否接收商城产品推送" v-if="form.supplier.storeType === 10">
        <el-radio-group v-model="form.supplier.productNotice">
          <el-radio :label="0">接收</el-radio>
          <el-radio :label="10">不接收</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启使用优惠券功能" v-if="form.supplier.storeType === 10">
        <el-radio-group v-model="form.supplier.usedCoupon">
          <el-radio :label="0">不可用</el-radio>
          <el-radio :label="1">可用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商家介绍" prop="supplier.description">
        <el-input type="textarea" v-model="form.supplier.description" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--管理用户-->
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>

    <supplier-choose ref="supplierChoose" :storeType="10" @closeDialog="supplierChooseOk"/>

  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js'
import Upload from '@/components/file/Upload'
import GetUser from '@/components/user/GetUser.vue'
import SupplierChoose from './dialog/SupplierChoose'

export default {
  components: {
    SupplierChoose,
    /*上传组件*/
    Upload,
    /*选择用户*/
    GetUser
  },
  data () {
    return {
      levelList: [{
        id: 0,
        name: '一级分销商'
      }, {
        id: 1,
        name: '二级分销商'
      }, {
        id: 2,
        name: '三级分销商'
      }, {
        id: 3,
        name: '四级分销商'
      }, {
        id: 4,
        name: '五级分销商'
      }],
      /*form表单数据*/
      form: {
        supplier: {
          logoId: 0,
          shopName: '',
          level: 0,
          parentId: 0,
          parentName: '',
          commissionRate: 0,
          businessId: 0,
          operatesId: 0,
          openService: 0,
          categoryId: '',
          userId: 0,
          storeType: 10,
          productNotice: 0,
          usedCoupon: 0
        },
      },
      logoFilePath: '',
      businessFilePath: '',
      operatesFilePath: '',
      /*是否打开添加弹窗*/
      open_add: false,
      storeList: [],
      category: [],
      /*是否上传图片*/
      isupload: false,
      loading: false,
      type: 'logo',
      open_user: false,
      userInfo: {}
    }
  },
  created () {
    /*获取列表*/
    this.getCategoryList()
  },
  methods: {
    /*获取广告类别*/
    getCategoryList () {
      let self = this
      let Params = {}

      SupplierApi.toaddSupplier(Params, true)
        .then(res => {
          self.category = res.data
          if (self.category.length > 0) {
            self.form.supplier.categoryId = self.category[0].categoryId
          }
        })
        .catch(error => {

        })
    },
    onSubmit () {
      let self = this
      let form = Object.assign({}, self.form)
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          if (form.supplier.storeType === 10) {
            if (form.supplier.level === 0) {
              form.supplier.parentId = 0
              form.supplier.parentName = ''
            }
          } else {
            form.supplier.level = 0
            form.supplier.parentId = 0
            form.supplier.parentName = ''
          }

          SupplierApi.addSupplier(form.supplier, true)
            .then(data => {
              self.loading = false
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，商户添加成功',
                  type: 'success'
                })
                if (form.supplier.storeType === 10) {
                  self.$router.push('/supplier/supplier/distributionstore')
                } else {
                  self.$router.push('/supplier/supplier/index')
                }

              } else {
                self.loading = false
              }
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },

    /*上传*/
    openUpload (e) {
      this.type = e
      this.isupload = true
    },

    /*获取图片*/
    returnImgsFunc (e) {
      if (e != null && e.length > 0) {
        if (this.type == 'logo') {
          this.logoFilePath = e[0].filePath
          this.form.supplier.logoId = e[0].fileId
        } else if (this.type == 'business') {
          this.businessFilePath = e[0].filePath
          this.form.supplier.businessId = e[0].fileId
        } else if (this.type === 'operates') {
          this.operatesFilePath = e[0].filePath
          this.form.supplier.operatesId = e[0].fileId
        }
      }
      this.isupload = false
    },


    /*取消*/
    cancelFunc () {
      this.$router.back(-1)
    },
    /*打开弹出层*/
    userClick () {
      this.open_user = true
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc (e) {
      if (e.type != 'error') {
        this.userInfo = e.params[0]
        this.form.supplier.userId = e.params[0].userId
      }
      this.open_user = false
    },
    onSupplierChoose () {
      this.$refs.supplierChoose.show()
    },
    supplierChooseOk (e) {
      console.log(e)
      if (e.type === 'success') {
        this.form.supplier.parentId = e.params.shopSupplierId || 0
        this.form.supplier.parentName = e.params.name || ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/add.vue